module.exports = __webpack_public_path__ + "static/media/icon.500480f7.svg";